export enum TransactionType {
  TABLE = 'TABLE',
  DELIVERY = 'DELIVERY',
  TAKE_AWAY = 'TAKE_AWAY',
  BOOKING = 'BOOKING',
}
